module.exports = __webpack_public_path__ + "c1b237ceca8c0307920a891b70475097.png";